import { render, staticRenderFns } from "./NationalPlanesPie.vue?vue&type=template&id=b9ff4b0c&scoped=true"
import script from "./NationalPlanesPie.vue?vue&type=script&lang=js"
export * from "./NationalPlanesPie.vue?vue&type=script&lang=js"
import style0 from "./NationalPlanesPie.vue?vue&type=style&index=0&id=b9ff4b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ff4b0c",
  null
  
)

export default component.exports